import { LegalLayout } from "@/components/LegalLayout";

const SALON = {
  name: "La Maison by FP, obrt za frizerske usluge",
  shortName: "La Maison by FP",
  owner: "Filip Pitinac",
  oib: "70763675453",
  mbo: "99228335",
  address: "Matije Gupca 6, 31400 Đakovo",
  email: "lamaisonbyfp@gmail.com",
  phone: "091 612 7321",
  ig: "@lamaison_fp",
  type: "Vezani obrt — frizerske usluge",
  registry: "Hrvatska obrtnička komora · Obrtni registar (e-Obrt)",
};

export default function Impressum() {
  return (
    <LegalLayout eyebrow="— Impressum" title="Informacije o pružatelju usluga" lastUpdated="prosinac 2025.">
      <p>
        Sukladno odredbama Zakona o elektroničkoj trgovini (NN 173/03, 67/08, 36/09, 130/11, 30/14, 32/19),
        Zakona o obrtu (NN 143/13, 127/19, 41/20) i Zakona o zaštiti potrošača, na ovoj stranici objavljujemo
        sve zakonski obvezne podatke o pružatelju usluga.
      </p>

      <h2>Podaci o obrtu</h2>
      <dl>
        <dt>Naziv obrta</dt><dd>{SALON.name}</dd>
        <dt>Skraćeni naziv</dt><dd>{SALON.shortName}</dd>
        <dt>Vlasnik / nositelj obrta</dt><dd>{SALON.owner}</dd>
        <dt>Sjedište</dt><dd>{SALON.address}</dd>
        <dt>OIB</dt><dd>{SALON.oib}</dd>
        <dt>MBO (Matični broj obrta)</dt><dd>{SALON.mbo}</dd>
        <dt>Vrsta obrta</dt><dd>{SALON.type}</dd>
        <dt>Registar</dt><dd>{SALON.registry}</dd>
      </dl>

      <h2>Kontakt</h2>
      <dl>
        <dt>Telefon</dt><dd><a href={`tel:+385${SALON.phone.replace(/\s/g, "").substring(1)}`}>{SALON.phone}</a></dd>
        <dt>E-mail</dt><dd><a href={`mailto:${SALON.email}`}>{SALON.email}</a></dd>
        <dt>Instagram</dt><dd><a href="https://instagram.com/lamaison_fp" target="_blank" rel="noreferrer">{SALON.ig}</a></dd>
      </dl>

      <h2>Nadležno tijelo nadzora</h2>
      <p>
        Tijelo koje izdaje obrtnicu i provodi nadzor: <strong>Hrvatska obrtnička komora</strong> putem Obrtnog
        registra (e-Obrt) i nadležnog ureda državne uprave u Osječko-baranjskoj županiji.
        Tržišnu inspekciju provodi <strong>Državni inspektorat Republike Hrvatske</strong>.
      </p>

      <h2>Rješavanje sporova</h2>
      <p>
        U slučaju spora, korisnik može podnijeti pritužbu izravno pružatelju usluga na navedeni e-mail.
        Sukladno Uredbi (EU) br. 524/2013 o online rješavanju potrošačkih sporova, dostupna je i platforma
        za online rješavanje sporova (ODR): <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr/</a>.
      </p>

      <p className="mt-12 italic text-[#B0C4B1]">
        Sve informacije objavljene su s dobrom namjerom i s najboljim znanjem. La Maison by FP zadržava
        pravo izmjene podataka uz prethodnu obavijest na ovoj stranici.
      </p>
    </LegalLayout>
  );
}
